import moment from 'moment'
import React from 'react'

import {
  Flex,
  IconButton 
} from '@driftt/dds'
import { faTrash } from '@driftt/dds.icons/dist/light/faTrash'
import {
  A,
  Avatar,
  Div,
  Input,
  Span,
  ToolTip 
} from '@driftt/tide-core'
import { resolveContactName } from 'utils/contact'

const SelectCell = ({ id }, onSelect, isSelected) => {
  return (
    <Input type="checkbox" checked={isSelected}
      onChange={(event) => onSelect(id, event)} />
  )
}

const NameCell = (contact) => {
  return (
    <Div className="contact-name-cell">
      <Avatar user={contact} type="user"/>
      <Div className="contact-name">
        <Span>
          <A href={`/contacts/details/${contact.id}`} target="_blank">
            <Div className="contact-name-cell--inner" data-private>
              {resolveContactName(contact, true)}
            </Div>
          </A>
        </Span>
      </Div>
    </Div>
  )
}

const ActionsCell = (contact, onDelete) => {
  return (
    <Flex alignItems="center" justifyContent="center">
      <IconButton
        icon={faTrash}
        title="Delete contact"
        onClick={() => onDelete(contact.id)}
      />
    </Flex>
  )
}

const EmailCell = ({ email }) =>
  <Div>
    <ToolTip flow="up" component={email ? email : 'Unknown'}>
      <Div className="contact-email-cell" data-private>
        {email ? email : 'Unknown'}
      </Div>
    </ToolTip>
  </Div>

const LeadStageCell = ({ attributes: { _classification } }) => _classification ? <Div>{_classification}</Div> : <Span>&mdash;</Span>

const LastContactedCell = ({ attributes: { last_contacted } }) => (
  last_contacted ? <Div>{moment(last_contacted).fromNow()}</Div> : <Span>&mdash;</Span>
)

export const RowFormatter = (
  contact, onDelete, onSelect, selectedContacts
) => {
  return {
    data: [
      { content: SelectCell(contact, onSelect, (selectedContacts && selectedContacts.includes(contact.id))) },
      { content: NameCell(contact) },
      { content: EmailCell(contact) },
      { content: LeadStageCell(contact) },
      { content: LastContactedCell(contact) },
      {
        content: ActionsCell(contact, onDelete),
        className: 'actions-cell' 
      },
    ]
  }
}
